// extracted by mini-css-extract-plugin
export default {"close":"MainMenu_close__7KGFT","menu":"MainMenu_menu__g0leX","indicator":"MainMenu_indicator__gpvH4"};